import { Injectable } from "@angular/core";
import { WeatherModel } from "../interfaces/weather.model";
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Http, Response } from "@angular/http";
import { map, concatMap, switchMap, catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { Ads } from "../interfaces/ads.type";
import { UnlServiceService } from "./unl-service.service";
@Injectable({
    providedIn: "root"
})
export class UnlAdsService {
    request_id = "";
    content_list_id = "";
    container = undefined;
    index = 0;
    list_size = 0;
    external_size = 0;
    widget_key = "vhWFtinM0GtBqXMtmXjq2f";
    widget_num = "114661";
    pageId = '';
    htmltype = 'default';
    renderhtml = 0;
    impressionurl = 'nattles/adimpression.php?request_id=5a00aa78e4b04701a44da561&c=1509993089250&itemid=AgQAAAAYGDU5ZTQyYzhkZTRiMDFjNTBkNjNlOGQ3NAgAAAFfkpno7AQAACBHBAAAE4gEAAAADAQAAYD8AAAEAABKTgQAAAAFBTk4NTU2BAAAAAABAAAABAAAAA0NbmlnaHRsaWZlLm5ldAQAAAAHB01JU1NJTkc%3D&impPixelType=REG&list_id=5a00aa78e4b04701a44da561$null$114661$Z-1$N-1$R-1$A-1.00$S2$EXRtrue$V-1$FISNfISSfIIPfESNfESSfEIPf$JEXPLOITATION$Ttrue$QI20$QU10$EXT13$CSECP$CPRND$IPINC$P0$_Age_0_1507391176704.00_Age_1_1507346219008.00_CDvp:1687*-1_2_44.00_Age_3_1506005483520.00_Flb_4_0.00_Flb_5_0.00_CDvp:1687*-1_6_63.00_CDvp:1687*-1_7_44.00_Flb_8_0.00_CDvp:1687*-1_9_75.00_Flb_10_0.00_Flb_11_0.00_CEcp:7985*95987_12_200000.00&this.widget_key=vhWFtinM0GtBqXMtmXjq2f';
    //impressionurl = 'http://papi.mynativeads.com/pub2/impressionpixel.json?request_id=5a00aa78e4b04701a44da561&c=1509993089250&itemid=AgQAAAAYGDU5ZTQyYzhkZTRiMDFjNTBkNjNlOGQ3NAgAAAFfkpno7AQAACBHBAAAE4gEAAAADAQAAYD8AAAEAABKTgQAAAAFBTk4NTU2BAAAAAABAAAABAAAAA0NbmlnaHRsaWZlLm5ldAQAAAAHB01JU1NJTkc%3D&impPixelType=REG&list_id=5a00aa78e4b04701a44da561$null$114661$Z-1$N-1$R-1$A-1.00$S2$EXRtrue$V-1$FISNfISSfIIPfESNfESSfEIPf$JEXPLOITATION$Ttrue$QI20$QU10$EXT13$CSECP$CPRND$IPINC$P0$_Age_0_1507391176704.00_Age_1_1507346219008.00_CDvp:1687*-1_2_44.00_Age_3_1506005483520.00_Flb_4_0.00_Flb_5_0.00_CDvp:1687*-1_6_63.00_CDvp:1687*-1_7_44.00_Flb_8_0.00_CDvp:1687*-1_9_75.00_Flb_10_0.00_Flb_11_0.00_CEcp:7985*95987_12_200000.00&this.widget_key=vhWFtinM0GtBqXMtmXjq2f';
    clickurl = "https://papi.mynativeads.com/pub2/redirect.json?sstmsg=59e42e13e4b01c50d63e8da9&iteratorId=5a01841ee4b064e1c212a301$redis$114661$Z-1$N-1$R-1$A-1.00$S2$EXRtrue$V-1$FISNfISSfIIPfESNfESSfEIPf$JEXPLOITATION$Ttrue$QI20$QU15$EXT13$CSECP$CPRND$IPINC$P0$_Rlt_0_28.15_Rlt_1_26.53_Rlt_2_1.62_Flb_3_0.00_CEcp:7985*95987_4_200000.00_Flb_5_0.00_Flb_6_0.00_Flb_7_0.00_CDvp:1687*-1_8_75.00_CDvp:1687*-1_9_44.00_Flb_10_0.00_CDvp:1687*-1_11_44.00_CDvp:1687*-1_12_37.00&clientKey=vhWFtinM0GtBqXMtmXjq2f&link=http%3A%2F%2Fnightlife.net%2Fvideos%2Ffloyd-mayweather-vs-conor-mcgregor-official-trailer%3Fcit%3Dall%26site%3Dunl&itemData=AgQAAAAYGDU5ZTQyZTEzZTRiMDFjNTBkNjNlOGRhOQgAAAFflewXmgQAAB8xBAAAAZAEAAAABAQAAXbzAAAEAABKTgQAAAAFBTk1OTg3BAAAAAABAAAABAAAAA0NbmlnaHRsaWZlLm5ldAQAAAAHB01JU1NJTkc%3D&request_id=5a01841ee4b064e1c212a301&isExternal=true&widget_num=114661"
    adresponse = [];
    //unladurl = 'http://papi.mynativeads.com/pub2/web/external.json?this.widget_key=vhWFtinM0GtBqXMtmXjq2f&widget_num=114661&pageId=' + Math.random().toString(36).substr(2) + '&url=http%3A%2F%2Fnightlife.net%2Fnews%2Findex%2F%3Fp%3D32&referrer=GOOGLE&list_size=6&external_size=3&_=' + Math.round(new Date().getTime() / 1000);
    unladurl = "./assets/json/advads.json";
    callback = undefined;
    adelement = '';
    pos = 'last';
    posarr = [];
    ispagination = false;
    adslistobj = {
        thirdparty: [],
        dst: [],
        dsp: [],
        rss: []
    };
    constructor(private http: HttpClient,private unlServiceService: UnlServiceService) {
        this.impressionurl = this.unlServiceService.basepath+'nattles/adimpression.php?request_id=5a00aa78e4b04701a44da561&c=1509993089250&itemid=AgQAAAAYGDU5ZTQyYzhkZTRiMDFjNTBkNjNlOGQ3NAgAAAFfkpno7AQAACBHBAAAE4gEAAAADAQAAYD8AAAEAABKTgQAAAAFBTk4NTU2BAAAAAABAAAABAAAAA0NbmlnaHRsaWZlLm5ldAQAAAAHB01JU1NJTkc%3D&impPixelType=REG&list_id=5a00aa78e4b04701a44da561$null$114661$Z-1$N-1$R-1$A-1.00$S2$EXRtrue$V-1$FISNfISSfIIPfESNfESSfEIPf$JEXPLOITATION$Ttrue$QI20$QU10$EXT13$CSECP$CPRND$IPINC$P0$_Age_0_1507391176704.00_Age_1_1507346219008.00_CDvp:1687*-1_2_44.00_Age_3_1506005483520.00_Flb_4_0.00_Flb_5_0.00_CDvp:1687*-1_6_63.00_CDvp:1687*-1_7_44.00_Flb_8_0.00_CDvp:1687*-1_9_75.00_Flb_10_0.00_Flb_11_0.00_CEcp:7985*95987_12_200000.00&this.widget_key=vhWFtinM0GtBqXMtmXjq2f';
     }
    getParameterByName(name, url) {
        if (!url)
            url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    replaceUrlParam(paramName, paramValue, newurl?) {
        var url = (newurl === undefined) ? this.unladurl : newurl;
        if (paramValue == null)
            paramValue = '';
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|$)')
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }
        url = url.replace(/\?$/, '');
        return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    };
    generateclickurl(iteratorId, link, itemData, request_id, origin, url?) {
        if (url === undefined)
            url = this.clickurl;
        if (iteratorId !== undefined && iteratorId != "")
            url = this.replaceUrlParam("iteratorId", iteratorId, url);
        url = this.replaceUrlParam("clientKey", this.widget_key, url);
        if (link !== undefined && link != "")
            url = this.replaceUrlParam("link", link, url);
        url = this.replaceUrlParam("itemData", itemData, url);
        url = this.replaceUrlParam("request_id", request_id, url);
        url = this.replaceUrlParam("isExternal", "true", url);
        url = this.replaceUrlParam("widget_num", this.widget_num, url);
        if (iteratorId !== undefined && iteratorId != "")
            url = this.replacecampignidandadidclick(url, origin);
        return url;
    };
    replacecampignidandadidclick(impixel, origin) {
        var org_url = impixel;
        impixel = this.getParameterByName("iteratorId", impixel);
        var implisturl = "";
        if (impixel !== null) {
            var impixel_arr = impixel.split("_CEcp:");
            if (impixel_arr.length === 2) {
                console.log(impixel_arr);
                var cecpstr = impixel_arr[1];
                var pos = cecpstr.indexOf("_");
                var r_cepstr = cecpstr.slice(pos);
                var originarr = origin.split("_");
                var campaignstr;
                var isdsp = origin.indexOf("D_");
                if (isdsp >= 0) {
                    campaignstr = originarr[originarr.length - 1] + "*" + r_cepstr;
                } else {
                    campaignstr = originarr[originarr.length - 1] + "*" + originarr[originarr.length - 2] + r_cepstr;
                }
                impixel_arr[1] = campaignstr;
                var impliststr = impixel_arr.join("_CEcp:");
                implisturl = this.replaceUrlParam("iteratorId", impliststr, org_url);
            }
        }
        return implisturl;
    };
    replacecampignidandadid(impixel?, origin?, pixeltype?) {
        var org_url = impixel;
        impixel = this.getParameterByName("list_id", impixel);
        var implisturl = "";
        if (impixel !== null) {
            var impixel_arr = impixel.split("_CEcp:");
            if (impixel_arr.length === 2) {
                console.log(impixel_arr);
                var cecpstr = impixel_arr[1];
                var pos = cecpstr.indexOf("_");
                var r_cepstr = cecpstr.slice(pos);
                var originarr = origin.split("_");
                var campaignstr;
                if (pixeltype !== undefined) {
                    campaignstr = originarr[originarr.length - 1] + "*" + r_cepstr;
                } else {
                    campaignstr = originarr[originarr.length - 1] + "*" + originarr[originarr.length - 2] + r_cepstr;
                }
                impixel_arr[1] = campaignstr;
                var impliststr = impixel_arr.join("_CEcp:");
                implisturl = this.replaceUrlParam("list_id", impliststr, org_url);
                if (pixeltype === undefined) {
                    pixeltype = "REG";
                }
                implisturl = this.replaceUrlParam("impPixelType", pixeltype, implisturl);
            }
        }
        return implisturl;
    };
    sentimpression() {
        console.log("scrolling");
        /*var allMods = this.container.find(".maindivadds");
        if (allMods !== undefined && allMods.length > 0) {
            allMods.each(function (i, el) {
                if ($(el).visible(true)) {
                    if (!$(el).hasClass("advisibleclass")) {
                        console.log($(el).data());
                        var urllen = $(el).data("impixellen");
                        if (urllen !== undefined && parseInt(urllen) > 0) {
                            for (var j = 0; j < parseInt(urllen); j++) {
                                var url = $(el).data("impixel" + j);
                                if (url !== undefined && url !== "") {
                                    var c = new AdErrorCallback(el, url);
                                    $.ajax({
                                        url: url,
                                        success: function (data) {
                                            console.log(data);
                                        }
                                    }).fail(c.callback);
                                }
                            }
                            $(el).addClass("advisibleclass");
                        }
                    }
                }
            });
        }*/
    };
    refetchad() {
        /*if (this.index >= (this.adresponse.length - 4)) {
            this.fetchad();
        } else {
            //callback();
        }*/
    };
    getParameterValue(url, name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regexS = "[\\?&]" + name + "=([^&#]*)";
        var regex = new RegExp(regexS);
        var results = regex.exec(url);
        if (results == null)
            return "";
        else
            return results[1];
    };
    getAds(list_size?: number, external_size?: number, widget_key?: string, widget_num?: string): ThirdpartyObservable<Ads> {
        if (list_size === 0)
            list_size = list_size;
        if (external_size === 0)
            external_size = external_size;
        if (widget_key !== undefined)
            this.widget_key = widget_key;
        if (widget_num !== undefined)
            this.widget_num = widget_num;
        this.unladurl = this.replaceUrlParam("list_size", list_size);
        this.unladurl = this.replaceUrlParam("external_size", external_size);
        this.unladurl = this.replaceUrlParam("this.widget_key", this.widget_key);
        this.unladurl = this.replaceUrlParam("widget_num", widget_num);
        return this.http.get<Ads>(this.unladurl)
            .pipe(
                catchError(err => {
                    console.log('Handling error locally and rethrowing it...', err);
                    return throwError(err);
                })
            );
    }
    getArrangedAds(adjson: Ads) {
        //console.log(adjson);
        this.adslistobj.dsp = [];
        this.adslistobj.dst = [];
        this.adslistobj.rss = [];
        this.adslistobj.thirdparty = [];
        var arrangedadjson = [];
        var thirdpartyads = adjson.thirdPartyAds;
        var thirdpartycount = 0;
        var requestid = adjson.reports.request_id;
        var content_list_id = adjson.reports.content_list_id;
        if (thirdpartyads !== undefined && thirdpartyads.length > 0) {
            /*for (var i in thirdpartyads) {
                var thirdpartyad = thirdpartyads[i];
                var thirdpartyadobj = this.getThirdpartyAds(thirdpartyad.url);
                thirdpartyadobj.subscribe(responseData => {
                    var dataobj = responseData["data"];
                    var urlimg = dataobj.content.image;
                    urlimg = urlimg.replace("default/files/", "default/files/imagecache/service_tabs1/");
                    var desccontent = "<p>" + dataobj.content.description.split(/\s+/).slice(0, 5).join(" ") + "...</p>";
                    var impixelarr = [];
            if (dataobj.impression_pixels !== undefined && dataobj.impression_pixels.length > 0) {
                for (var m = 0; m < dataobj.impression_pixels.length; m++) {
                    var url = dataobj.impression_pixels[m];
                    if (url.toString().toLowerCase().indexOf("papi") !== -1) {
                        url = "http:" + url;
                        url = this.replacecampignidandadid(url, origin);
                    }
                    impixelarr.push(url);
                }
            } else {
               /* var url = tadobj.impressionurl;
                url = tadobj.replaceUrlParam("request_id", obj.request_id, url);
                url = tadobj.replaceUrlParam("list_id", obj.content_list_id, url);
                url = tadobj.replaceUrlParam("itemid", obj.itemid, url);
                url = tadobj.replacecampignidandadid(url, obj.origin);
                impixelarr.push(url);
            }
                    var thirdpartyadobjdata = {
                        image: urlimg,
                        title:dataobj.content.title,
                        body:desccontent,
                    };
                });

                var thirddataobj = thirdpartyad.data;
                var origin = thirdpartyad.origin;
                var impression_pixels = thirddataobj.impression_pixels;
                var itemid = thirdpartyad.id;
            }*/
        }
        var items = adjson.items;
        for (var k in items) {
            var origin = items[k].origin;
            var itemid = items[k].id;
            var dataobj = items[k].data;
            var content_list_id = adjson.reports.content_list_id;
            var urlimg = dataobj.content.image;
            urlimg = urlimg.replace("default/files/", "default/files/imagecache/service_tabs1/");
            var desccontent = "<p>" + dataobj.content.description.split(/\s+/).join(" ") + "...</p>";
            var impixelarr = [];
            if (dataobj.impression_pixels !== undefined && dataobj.impression_pixels.length > 0) {
                for (var m = 0; m < dataobj.impression_pixels.length; m++) {
                    var url = dataobj.impression_pixels[m];
                    if (url.toString().toLowerCase().indexOf("papi") !== -1) {
                        url = "http:" + url;
                        url = this.replacecampignidandadid(url, origin);
                    }
                    impixelarr.push(url);
                }
            } else {
                var url = this.impressionurl;
                url = this.replaceUrlParam("request_id", requestid, url);
                if (content_list_id !== undefined && content_list_id != "") {
                    url = this.replaceUrlParam("list_id", content_list_id, url);
                }
                url = this.replaceUrlParam("itemid", itemid, url);
                //url = this.replacecampignidandadid(url, origin);
                impixelarr.push(url);
            }
            var ourl = dataobj.action.originalUrl;
            if (ourl !== undefined && ourl.indexOf("http") === -1) {
                ourl = "http:" + ourl;
            }
            var trackurl = dataobj.action.url;
            if (trackurl === "") {
                trackurl = undefined;
            }
            var clickurl;
            if ((origin.indexOf("D_") !== -1) || (origin.indexOf("E_") !== -1)) {
                clickurl = this.generateclickurl(content_list_id, ourl, itemid, requestid, origin, trackurl);
            } else {
                clickurl = trackurl
            }
            var customtrackurl=this.getPathFromUrl(clickurl);
            clickurl=clickurl.replace(customtrackurl,this.unlServiceService.basepath+"adtrack.php");
            var adobjdata = {
                image: urlimg,
                body: desccontent,
                title: dataobj.content.title,
                impixels: impixelarr,
                clickurl: clickurl
            };
            if (origin.indexOf("D_") !== -1) {
                this.adslistobj.dsp.push(adobjdata);
            } else if (origin.indexOf("E_") !== -1) {
                this.adslistobj.dst.push(adobjdata);
            } else if (origin.indexOf("O_") !== -1) {
                this.adslistobj.rss.push(adobjdata);
            }

        }
        for (var i in this.adslistobj.dst) {
            arrangedadjson.push(this.adslistobj.dst[i]);
        }
        for (var i in this.adslistobj.dsp) {
            arrangedadjson.push(this.adslistobj.dsp[i]);
        }
        for (var i in this.adslistobj.rss) {
            arrangedadjson.push(this.adslistobj.rss[i]);
        }
        //console.log(arrangedadjson);
        return arrangedadjson;
    }
    getThirdpartyAds(url: string): ThirdpartyObservable<{}> {
        return this.http.get<{}>(url)
            .pipe(
                catchError(err => {
                    console.log('Handling error locally and rethrowing it...', err);
                    return throwError(err);
                })
            );
    }
    getPathFromUrl(url) {
        return url.split("?")[0];
      }
    /*fetchad(list_size, external_size, callback, container, widget_key, widget_num) {
        if (list_size === 0)
            list_size = list_size;
        if (external_size === 0)
            external_size = external_size;
        if (container === undefined)
            container = $(container);
        if (callback !== undefined) {
            callback = callback;
        }
        if (this.widget_key !== undefined)
            this.widget_key = this.widget_key;
        if (widget_num !== undefined)
            this.widget_num = widget_num;
        this.unladurl = this.replaceUrlParam("list_size", list_size, undefined);
        this.unladurl = this.replaceUrlParam("external_size", external_size, undefined);
        this.unladurl = this.replaceUrlParam("this.widget_key", this.widget_key, undefined);
        this.unladurl = this.replaceUrlParam("widget_num", widget_num, undefined);
        this.index = 0;
        if (!this.ispagination)
            this.adresponse = [];
        this.http.get(this.unladurl).concatMap(adjson => {
            const data = adjson.json().data;
        }).subscribe((adjson: any) => {

        });
    };*/
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(
            'Something bad happened; please try again later.');
    };
}
export class ThirdpartyObservable<T> extends Observable<T>{
    constructor() {
        super();
        console.log(this);
    }
}